import DevChampsApplyStatusRs from '@domain/rs/dchamps/DevChampsApplyStatusRs';

export default class DevChampsApplyStatusVO {
  isAllApplied: boolean;
  isPaccApplied: boolean;
  isPstApplied: boolean;

  constructor(rs: DevChampsApplyStatusRs) {
    this.isAllApplied = rs.paccApplied && rs.pstApplied;
    this.isPaccApplied = rs.paccApplied;
    this.isPstApplied = rs.pstApplied;
  }
}
